import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

const InteractiveElement = ({
  as: Element = 'div', // Default to 'div', but can be 'span' or 'a', etc.
  children,
  onClick,
  href,
  role = '',
  tabIndex = 0,
  ariaLabel,
  ariaChecked,
  className,
  style,
  id,
  value,
  disabled = false,
  ...rest
}) => {
  const handleKeyDown = event => {
    if ((event.key === 'Enter' || event.key === ' ') && onClick && !disabled) {
      event.preventDefault();
      onClick();
    }
  };

  const commonProps = {
    className,
    style,
    role,
    tabIndex: disabled ? -1 : tabIndex,
    'aria-label': ariaLabel,
    'aria-checked': ariaChecked,
    id,
    value,
    onClick: !disabled ? onClick : undefined,
    onKeyDown: !disabled ? handleKeyDown : undefined,
    ...rest
  };

  let component;

  switch (Element) {
    case 'a':
      if (href) {
        commonProps.href = href;
      }
      component = <a {...commonProps}>{children}</a>;
      break;

    case 'Row':
      component = <Row {...commonProps}>{children}</Row>;
      break;

    case 'Col':
      component = <Col {...commonProps}>{children}</Col>;
      break;

    case 'Container':
      component = <Container {...commonProps}>{children}</Container>;
      break;

    default:
      component = <Element {...commonProps}>{children}</Element>;
  }

  return component;
};

InteractiveElement.propTypes = {
  as: PropTypes.oneOf(['div', 'span', 'a', 'button', 'Row', 'Container' ]), // Specifies the element type
  children: PropTypes.node,
  onClick: PropTypes.func,
  href: PropTypes.string, // Only used when `as="a"`
  role: PropTypes.string,
  tabIndex: PropTypes.number,
  ariaLabel: PropTypes.string,
  ariaChecked: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
  id: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool
};

export default InteractiveElement;
